var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signature"},[_c('p',[_vm._v("© "+_vm._s(new Date().getFullYear())+" Gourmetech - Todos os direitos reservados.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }